import addVendorScript from '@/shared/util/addVendorScript';

addVendorScript('https://cdn.checkhq.com/component-initialize.js');
addVendorScript('https://cdn.checkhq.com/onboard-initialize.js');
